import { put, takeLatest, call, spawn, all } from 'redux-saga/effects';
import { executiveActions } from '../../../application/actions/executive';

import { loadingActions } from '../../../application/actions/ui_loaders';

import api from '../../api';

const apiExecutive = api(process.env.REACT_APP_EXECUTIVE_API);

export function* fetchExecutive(action) {
  try {
    yield put(loadingActions.changeStatusLoadingFetchExecutive({ isLoading: true }));

    const response = yield call(apiExecutive.post, 'v1/consultar', action.payload);
    const { data } = response;

    if (data)
      yield all([
        put(loadingActions.changeStatusLoadingFetchExecutive({ isLoading: false })),
        put(executiveActions.fetchExecutiveSuccess(data)),
      ]);
    else
      yield all([
        put(loadingActions.changeStatusLoadingFetchExecutive({ isLoading: false })),
        put(executiveActions.fetchExecutiveError(response.error)),
      ]);
  } catch (err) {
    console.error('executive saga error:', err);
    yield all([
      put(executiveActions.fetchExecutiveError({ code: 500 })),
      put(loadingActions.changeStatusLoadingFetchExecutive({ isLoading: false })),
    ]);
  }
}

export function* watchFetchExecutive() {
  yield takeLatest(executiveActions.fetchExecutive.type, fetchExecutive);
}
/* istanbul ignore next */
export default function* executiveSaga() {
  yield spawn(watchFetchExecutive);
}
